import React, { useState } from "react";
import Loader from "../componment/loader/Loader.jsx";
import { addContactDetails } from "../helper/services/contactServices";
import swal from 'sweetalert';


const Contact = () => {
const [contactDetails,setContactDetails]=useState()
const [isLoader,setIsLoader]=useState(false)

const handaleOnChange =(e)=>{
  const target = e.target;
 const {name,value}=target

  setContactDetails({
    ...contactDetails,
    [name]: value
  });
}

const handaleSubmit=async(e)=>{
  e.preventDefault()
  try {
    setContactDetails({name:"",email:"",message:""})
    setIsLoader(true); 
    // setTimeout(() => setIsLoader(false), 1500);
    const Response = await addContactDetails(contactDetails);
    if (Response.message != "success") { 
        swal ( "Oops" ,  "Something went wrong!" ,  "error" )
    }
    if (Response.message == "success") { 
      swal("Thank you", "Our team will reach out to you in the next 24 hours", "success");
      setIsLoader(false);
    }
  } catch (error) {
    swal ( "Oops" ,  "Something went wrong!" ,  "error" )
    setIsLoader(false);
  }
}

  return (
    <>
    <form onSubmit={(e)=>handaleSubmit(e)}>
    
      <div
        style={{
          backgroundImage: "url(../images/ContactBackground.png)",
          // backgroundImage:"linear-gradient(179deg, #07070B 41.56%, #2B2D41 101.56%)",
          display: "flex",
          justifyContent: "center",
          paddingTop: "140px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position:"relative"
        }}
      >
    <div  
    className="zeroBackground"
    style={{
          position:"absolute",
          left:"44%",
          opacity:"0.1",
          top:"-80px",
          zIndex:0
        }}>     <img
                src="../images/Zero.png"
                style={{ marginTop: "20px" }}
              ></img></div>
        <div style={{  zIndex:1}}>
          {" "}
          <div 
          className="contactOne"
          style={{ position: "absolute", left: "22%", top: "165px" }}>
          
            <div
              style={{
                fontStyle: "italic",
                fontSize: "42px",
                marginRight: "90px",
                color: "white",
                fontFamily: "Didot",
                textAlign: "end",
              }}
            >
              Join
            </div>
            <div
              style={{
                fontSize: "42px",
                color: "white",
                textAlign: "end",
                position: "relative",
                top: "-15px",
                marginRight: "30px",
              }}
            >
              our
            </div>
            <div
              style={{
                fontStyle: "italic",
                fontSize: "42px",
                color: "white",
                position: "relative",
                top: "-30px",
                left: "25px",
                textAlign: "end",
                fontFamily: "Didot",
              }}
            >
              {" "}
              List
            </div>
          </div>
          <div
            className="contactTwo"
          
            style={{
              fontSize: "16px",
              color: "white",
              padding: "100px 80px",
              background: "#151515",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              boxShadow: "0px 4px 14px rgba(0, 0, 0, 0.25)",
            }}
          >
            <div>Your Name*</div>
            <div>
              <input
               className="inputTag"
               autocomplete="off"
                name="name"
                id="name"
                value={contactDetails?.name}
                onChange={(e)=>handaleOnChange(e)}
                style={{
                  height: "39px",
                  width: 350,
                  border: "1px solid #292929",
                  borderRadius: "2px",
                  backgroundColor: "#292929"
                }}
              ></input>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              E-Mail Address*
            </div>
            <div>
              <input
                className="inputTag"
                name="email"
                id="email"
                autocomplete="off"
                value={contactDetails?.email}
                onChange={(e)=>handaleOnChange(e)}
                style={{
                
                  height: "39px",
                  width: 350,
                  border: "1px solid #292929",
                  borderRadius: "2px",
                  backgroundColor: "#292929",
                  
                }}
              ></input>
            </div>
            <div
              style={{
                marginTop: "20px",
              }}
            >
              Message
            </div>
            <div>
              <textarea
                className="inputTag"
                name="message"
                id="message"
                value={contactDetails?.message }
                onChange={(e)=>handaleOnChange(e)}
                style={{
                  width: 350,
                  minHeight: 110,
                  border: "1px solid #292929",
                  borderRadius: "2px",
                  resize: "none",
                }}
              ></textarea>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {isLoader ?<><Loader height="40px" width="40px"/></> :
              <button
                type="submit"
                className="submitButton"
                style={{
                  width: "140px",
                  padding: "8px 12px",
                  borderRadius: "30px",
                  backgroundColor: "#34294499",
                  border:"0px solid",
                  textAlign: "center",
                  color:"white"
                }}
              >
                Submit
              </button>}
            </div>
          </div>
        </div>
      </div>
      </form>
    </>
  );
};

export default Contact;
